import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";

import {
  IonIcon,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
  IonProgressBar,
  IonSearchbar,
  isPlatform,
  useIonModal,
  IonImg,
  IonItem,
  IonLabel,
  IonText,
} from "@ionic/react";

import { add, arrowBack } from "ionicons/icons";

import UsersListItem from "./components/UsersListItem";
import UserDetail from "./components/UserDetail";

import * as Models from "../../models";
import { SessionContext } from "../../session";

const UsersPage: React.FC = observer(() => {
  const [searchText, setSearchText] = useState("");
  const [selectedItem, setSelectedItem] = useState<Models.User>();

  const handleDismiss = () => {
    dismiss();
  };

  const session = useContext(SessionContext);

  const [present, dismiss] = useIonModal(UserDetail, {
    session: session,
    user: selectedItem,
    onDismiss: handleDismiss,
  });

  if (!session) {
    return <></>;
  }

  const users = session.users?.data?.filter(
    (user) =>
      ((user.fullName ?? "").trim() !== "" &&
        (user.fullName ?? "")
          .toUpperCase()
          .includes((searchText ?? "").toUpperCase())) ||
      ((user.email ?? "").trim() !== "" &&
        (user.email ?? "")
          .toUpperCase()
          .includes((searchText ?? "").toUpperCase()))
  );

  return (
    <IonPage>
      <IonHeader
      //className="ion-no-border"
      >
        <IonToolbar color="primary">
          <IonButtons slot="start">
            {session.windowSize === "small" ? (
              <>
                {/*<IonBackButton defaultHref={`/conversations`}></IonBackButton>*/}
                <IonButton routerLink="/admin">
                  <IonIcon icon={arrowBack} />
                </IonButton>
              </>
            ) : (
              <></>
            )}
          </IonButtons>
          <IonTitle>Users</IonTitle>
          <IonButtons slot="end">
            <IonButton
              shape="round"
              expand="block"
              size="large"
              fill="solid"
              color="light"
              onClick={() => {
                setSelectedItem(new Models.User(session, "userProfiles"));
                present({ cssClass: "modal-create-view" });
              }}
            >
              <IonIcon icon={add} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonProgressBar hidden={!session.users?.loading} type="indeterminate" />
        <IonSearchbar
          color="light"
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value!)}
        ></IonSearchbar>
        <IonList>
          {users && users.length > 0
            ? users.map((item) => (
                <UsersListItem
                  key={item.id}
                  user={item}
                  onSelectItem={(item) => {
                    setSelectedItem(item);
                    present({ cssClass: "modal-edit-view" });
                  }}
                />
              ))
            : (searchText ?? "") !== "" && (
                <IonItem style={{}} lines="none">
                  <IonLabel className="ion-text-center">
                    <IonImg
                      style={{
                        maxWidth: "250px",
                        margin: "auto",
                        marginTop: "69px",
                      }}
                      src={
                        (searchText ?? "") === ""
                          ? "/assets/images/artboard007.png"
                          : "/assets/images/artboard008.png"
                      }
                    />
                    <p>
                      <strong>
                        <IonText
                          color="dark"
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          {(searchText ?? "") === ""
                            ? ""
                            : " No Search Results"}
                        </IonText>
                      </strong>
                    </p>
                    <p
                      style={{
                        marginTop: "5px",
                      }}
                    >
                      <IonText
                        color="medium"
                        style={{
                          fontSize: "16px",
                        }}
                      ></IonText>
                    </p>
                  </IonLabel>
                </IonItem>
              )}
        </IonList>
      </IonContent>
    </IonPage>
  );
});

export default UsersPage;
